// extracted by mini-css-extract-plugin
export default {"base":"password-input_base__eRLD9","action-label":"password-input_action-label__jbe84","password-repetition-input":"password-input_password-repetition-input__Sc5A2"};